export default [
	{
		label: 'flights.manualScreen.sameDayToggler.sameDay',
		value: true
	},
	{
		label: 'flights.manualScreen.sameDayToggler.nextDay',
		value: false
	}
]
